import React, { useState } from "react";
import { useParams } from "react-router";

function FinalImage() {
  const { id } = useParams();
  const { origin } = window.location;
  const [scale, setScale] = useState(1);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const zoom = (event, factor) => {
    event.preventDefault();
    const delta = factor * 0.01;
    const newScale = Math.min(Math.max(0.5, scale + delta), 3); // Restrict scale between 0.5 and 5
    if (scale === 3 && newScale === 3 ) {
      setScale(1);
      setPosition({ x: 0, y: 0 });
    } else setScale(newScale);
  };

  const handleMouseDown = (event) => {
    event.preventDefault();
    setIsDragging(true);
    setDragStart({
      x: event.clientX - position.x,
      y: event.clientY - position.y,
    });
  };

  const handleMouseMove = (event) => {
    if (!isDragging) return;

    if (scale === 1) {
      setPosition({ x: 0, y: 0 });
      return
    }

    const { bottom,  top } = document.getElementById("FinalImage").getBoundingClientRect();

    if ((event.clientY - dragStart.y) * 0.5 + top > 100 || (event.clientY - dragStart.y) * 0.5 + bottom  < (window.innerHeight - 100)){
        return
    }

    setPosition({
      x: (event.clientX - dragStart.x) * 0.5,
      y: (event.clientY - dragStart.y) * 0.5,
    });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  return (
    <div className="App" onWheel={(event) => zoom(event, -1)}>
      <div
        className="finalImageContainer"
        style={{
          cursor: isDragging ? "grabbing" : "grab",
        }}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        // onClick={(event) => zoom(event, 200)}
        onDoubleClick={(event) => zoom(event, 200)}
      >
        <img
            id="FinalImage"
          className="FinalImage"
          src={`blob:${origin}/${id}`}
          alt=""
          style={{
            transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
            transition: "transform 0.1s",
            userSelect: "none",
          }}
        />
      </div>
    </div>
  );
}

export default FinalImage;
